export function textDimensions(word, ref) {
    var _a, _b;
    const textContent = document.createTextNode(word);
    const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    textElement.setAttribute('class', 'test');
    textElement.appendChild(textContent);
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.appendChild(textElement);
    const box = textElement.getBBox();
    (_b = ref.current) === null || _b === void 0 ? void 0 : _b.removeChild(textElement);
    return box;
}
//# sourceMappingURL=utils.js.map